import type { FocusSnapPreview } from "@/lib/frame-window-gestures";

/** Where a focus window dragged to a surface edge will snap. */
export function FocusSnapPreviewBox({
  preview,
}: {
  preview: FocusSnapPreview;
}) {
  return (
    <div
      className="pointer-events-none absolute z-20 rounded-frame border border-[color-mix(in_srgb,var(--color-accent)_55%,transparent)] bg-[color-mix(in_srgb,var(--color-accent)_10%,transparent)] shadow-[inset_0_0_0_1px_rgb(255_255_255/0.08)]"
      style={{
        left: preview.box.x,
        top: preview.box.y,
        width: preview.box.width,
        height: preview.box.height,
      }}
      data-testid={`focus-snap-preview-${preview.mode}`}
      aria-hidden="true"
    />
  );
}
